import { ReactionResponse } from "@shared/Types/Reactions/ReactionTypes.types";
import { publishOnReactionEvent } from "../Events/OnReactionEvent";
import { ReactionAction, ReactionEntityName } from "../Reactions.types";

export type ReactionActorActionMap = {
    [key in ReactionAction]: (
        entityId: string,
        reactionName: string,
    ) => Promise<ReactionResponse>;
};

export type ReactionActorConstructor = new (
    entityId: string,
) => AbstractReactionActor;

export abstract class AbstractReactionActor {
    protected abstract readonly actionMap: ReactionActorActionMap;

    constructor(public readonly entityId: string) {}

    abstract readonly entityType: ReactionEntityName;
    protected abstract readonly preAction: () => void;

    async performAction(
        reactionAction: ReactionAction,
        reactionName: string,
    ): Promise<ReactionResponse> {
        this.preAction();
        const reactions = await this.actionMap[reactionAction](
            this.entityId,
            reactionName,
        );
        publishOnReactionEvent(this.entityType, this.entityId, reactions);

        return reactions;
    }
}
